import { SoftwareUpdateWizard } from "@/components/software-updates/wizard/SoftwareUpdateWizard";

export default function NewSoftwareUpdatePolicyPage() {
  return <SoftwareUpdateWizard />;
}
